import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import { bool, func, object } from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { BANDEIRAS_IMAGES } from '../../../../constants'

const CartaoVigente = styled.div`
  ${StyleGuide.tipografia.textoGrande};

  .title {
    ${StyleGuide.boldFonte};
    color: ${StyleGuide.cores.cinza400};
  }

  p {
    margin: 0;
  }
`

const Modal = styled.div`
  background-color: ${StyleGuide.cores.branco};
  border-radius: 10px;
  margin: 0 auto;
  max-width: 500px;
  padding: 44px;
  position: relative;
  text-align: center;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  z-index: 10;

  @media(max-width: ${StyleGuide.mediaQuery.smallpc}) {
    padding: 15px;
    width: 95%;
  }
`

const ModalWapper = styled.div`
  background-color: rgba(19, 26, 45, 0.5);
  display: ${( { open } ) => open ? 'block' : 'none'};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;

  a,
  button {
    padding: 15px 28px;

    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      width: 100%;
    }
  }

  button {
    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      margin-bottom: 10px;
    }
  }
`

const Titulo = styled.h3`
  ${StyleGuide.tipografia.titulo3};
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.boldFonte};
  margin: 25px auto;;
  max-width: 80%;
`
const Descricao = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 10px auto 10px;

  .numero {
    ${StyleGuide.tipografia.textoGrande};
    margin-right: 12px;
    letter-spacing: 1px;

    &__vigente {
      color: ${StyleGuide.cores.cinza400};
      margin-right: 12px;
      letter-spacing: 1px;
    }
  }
`

const CartaoBandeira = styled.div`
  background-image: url( ${( { bandeira } ) => bandeira && bandeira} );
  background-position: center;
  background-repeat: no-repeat;
  background-size: 102%;
  border: 1px solid #efefef;
  border-radius: 5px;
  height: 31px;
  margin-right: 21px;
  max-width: 42px;
  width: 100%;
`

const WrapperButton = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px auto 0;
  max-width: 72%;

  @media( max-width: ${StyleGuide.mediaQuery.smallpc}) {
    max-width: 62%;
  }

  @media( max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }
`

const ModalConfirmaCartaoVigente = ( { cartaoAdicionado, cartaoVigente, open, onCancelar, onConfirmar } ) => {
  return (
    <ModalWapper open={ open }>
      <Modal>
        <CartaoVigente>
          <p className="title">
            Atualmente, o cartão vigente é:
          </p>

          <Descricao>
            <CartaoBandeira
              bandeira={ BANDEIRAS_IMAGES[ cartaoVigente.bandeira ] }
            />

            <p className="cartao-vigente">
              <span className="numero__vigente">
                ****
              </span>

              <span className="numero__vigente">
                ****
              </span>

              <span className="numero__vigente">
                ****
              </span>

              <span className="numero__vigente">
                { cartaoVigente.ultimosDigitos }
              </span>
            </p>
          </Descricao>
        </CartaoVigente>

        <Titulo>
          Deseja alterar seu cartão vigente para este cartão?
        </Titulo>

        <Descricao>
          <CartaoBandeira
            bandeira={ BANDEIRAS_IMAGES[ cartaoAdicionado.bandeira ] }
          />

          <span className="numero">
            ****
          </span>

          <span className="numero">
            ****
          </span>

          <span className="numero">
            ****
          </span>

          <span className="numero">
            { cartaoAdicionado.ultimosDigitos }
          </span>
        </Descricao>

        <WrapperButton>
          <Button
            invertido
            onClick={ onCancelar }
            target="_self"
            tema={ Button.BOTAO_CURADORIA }
          >
            Cancelar
          </Button>

          <Button
            onClick={ onConfirmar }
            tema={ Button.BOTAO_CURADORIA }
          >
            Sim, alterar
          </Button>
        </WrapperButton>
      </Modal>
    </ModalWapper>
  )
}

ModalConfirmaCartaoVigente.propTypes = {
  'cartaoAdicionado': object.isRequired,
  'cartaoVigente': object.isRequired,
  'onCancelar': func,
  'onConfirmar': func,
  'open': bool
}

ModalConfirmaCartaoVigente.defaultProps = {
  'onCancelar': () => {},
  'onConfirmar': () => {},
  'open': false
}

export default ModalConfirmaCartaoVigente
